export const SelectBox = ({label, options, requested, value, setValue}) => {
    const handelChanges = (inputValue) => {
        setValue(inputValue);
    }


    return (
        <fieldset className={'h-full flex flex-col justify-center'} aria-label="orderTypes">
            {(label !== "") && (
                <h4 className="font-semibold text-xl mb-8 text-gray-900">
                    {label}<span className='ml-1 text-sm font-light text-indigo-900 text-xs'>{requested ? '(Pflichtfeld)' : ''}</span>
                </h4>
            )}
            <div className="gap-4 flex flex-col flex-1 max-w-[500px]">
                {options?.map((option) => {
                    const isSelected = value === option.id;
                    return (
                        <div key={option.id} className={`${value === option.id ? 'bg-gray-200' : ''} flex items-start  text-sm border-gray-300 p-2 rounded-lg h-full`}>
                            <div className="flex h-6 items-center">
                                <label htmlFor={option.id} className="sr-only">
                                    {option.name}
                                </label>
                                <input
                                    id={option.id}
                                    name={option.id}
                                    type="radio"
                                    checked={isSelected ? true : false}
                                    value={option.id}
                                    onChange={(e) => handelChanges(e.target.value)}
                                    aria-describedby={`${option?.id}-description`} 
                                    className={`${isSelected ? 'border-gray-600 text-gray-600' : 'text-gray-550 border-gray-550'} h-6 w-6  text-sm focus:ring-0 focus:ring-offset-0 cursor-pointer`}
                                />
                            </div>
                            <div className="ml-3 text-sm flex flex-col gap-2">
                                <label 
                                    htmlFor={option.id}
                                    className={`${isSelected ? "text-gray-900" : "cursor-pointer text-gray-550"} font-bold`}
                                >
                                    {option.name}
                                </label>
                                <p 
                                    id={`${option?.id}-description`}
                                    className={`${isSelected ? "text-gray-900" : "text-gray-550"}`}
                                >
                                    {option.description}
                                </p>
                            </div>
                        </div>   
                    )
                })}
            </div>
        </fieldset>
    )
}
